module.exports = __webpack_public_path__ + "static/media/flag-th.1ac3dbbe.webp";